export default "__VITE_ASSET__CovdOyz$__"